<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication" style="margin-top:3em;">For Florence Jacobson</p>
<p class="ORIM-Dedication">My mother’s life changed dramatically the moment her father succumbed to a fatal heart attack at the dinner table. Following that traumatic event, she took on the challenge of raising her younger brother while my grandmother went to work in Manhattan. A dozen years later, during my childhood, whenever there was an issue in our Queens neighborhood, be it a broken streetlight or a problem at our local elementary school, people knew they could rely on my mother to raise hell—and get the problem taken care of. She fought when others yielded. She persisted when others acquiesced. Most importantly, my mother taught me perseverance, a vital trait without which I never would’ve been able to overcome the obstacles I’ve encountered in life. While each of my novels could have been dedicated to my mother, my milestone tenth book is for her.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Jacobson_LostCodex_1P-1.vue?36b91ecb